const TARGET_SELECTOR = '[data-enchliving-product-count]';
const CARD_SELECTOR = 'product-card';
const PRODUCT_LIST_SELECTOR = 'product-list';
const INITIAL_DELAY_MS = 180;
const DEBOUNCE_MS = 80;

function isCardVisible(card) {
  if (card.offsetParent !== null) return true;
  const style = window.getComputedStyle(card);
  return style.display !== 'none' && style.visibility !== 'hidden';
}

function countVisibleCards(scope) {
  const cards = (scope || document).querySelectorAll(CARD_SELECTOR);
  let count = 0;
  cards.forEach((card) => {
    if (isCardVisible(card)) count += 1;
  });
  return count;
}

function formatCount(target, count) {
  if (count === 0) {
    return target.dataset.countZero || '';
  }
  if (count === 1) {
    return target.dataset.countOne || '';
  }
  const template = target.dataset.countOther || '';
  return template.replace('__COUNT__', String(count));
}

function paint(target, count) {
  const text = formatCount(target, count);
  if (target.textContent !== text) {
    target.textContent = text;
  }
}

function recountAll() {
  const targets = document.querySelectorAll(TARGET_SELECTOR);
  if (targets.length === 0) return;
  const count = countVisibleCards(document);
  targets.forEach((target) => paint(target, count));
}

let debounceTimer = null;
function scheduleRecount(delay) {
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    debounceTimer = null;
    recountAll();
  }, typeof delay === 'number' ? delay : DEBOUNCE_MS);
}

function observeProductLists() {
  const lists = document.querySelectorAll(PRODUCT_LIST_SELECTOR);
  if (lists.length === 0) return;

  const observer = new MutationObserver(() => scheduleRecount());
  lists.forEach((list) => {
    observer.observe(list, { childList: true, subtree: false });
  });
}

function observeBodyClass() {
  const observer = new MutationObserver(() => scheduleRecount());
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

function init() {
  if (window.__enchlivingProductCountInit) return;
  window.__enchlivingProductCountInit = true;

  scheduleRecount(INITIAL_DELAY_MS);

  observeProductLists();
  observeBodyClass();

  document.addEventListener('facet:updated', () => {
    observeProductLists();
    scheduleRecount(INITIAL_DELAY_MS);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

export {};
